import type { TFrameOptions, IRunPlan, TVerification } from '../types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface HIFWindow extends Window {
  HIP: {
    version: string;
  };
}

declare let window: HIFWindow;

type TVersionHIFVerification = TVerification & {
  settings: {
    min: string;
    max: string;
  };
};

const R = {
  findNumbers: /\d+/g
};

const versionToValue = (version: string): number =>
  (version.match(R.findNumbers) ?? [])
    // only use major, minor, patch
    //
    .slice(0, 3)
    .reverse()
    .map((_) => Number.parseInt(_))
    .map((v, index) => v * Math.pow(10, index))
    .reduce((_, v) => _ + v, 0);

export default function (verification: TVersionHIFVerification, runPlan: IRunPlan, frameOptions: TFrameOptions) {
  if (!window.HIP) {
    return;
  }

  const ver = window.HIP.version;
  if (ver == null) {
    return;
  }

  const min = verification?.settings?.min;
  const max = verification?.settings?.max;

  const verVal = versionToValue(ver);

  if (min != null && versionToValue(min) > verVal) {
    throw `hif version ${ver} is lower than minimum required ${min}`;
  }

  if (max != null && versionToValue(max) < verVal) {
    throw `hif version ${ver} is higher than maximum required ${max}`;
  }
}
